module.exports = __webpack_public_path__ + "img/6-consumers-and-stylists-tape.png";